import React, { Component } from 'react';
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import NavbarSelector from '../NavbarSelector'
import ModalRoutes from './ModalRoutes';

import axios from "axios";
import { LoadingIcon } from '../Common/Loading_Icon';
import { Trans } from 'react-i18next';

class Unsubscribe extends Component {
    constructor(props) {
        super(props);

        this.selectAll = this.selectAll.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.unsubscribeAll = this.unsubscribeAll.bind(this);
        this.setNotifications = this.setNotifications.bind(this);
        this.calculateSave = this.calculateSave.bind(this);
        this.calculateChecked = this.calculateChecked.bind(this);
        this.submitNotifications = this.submitNotifications.bind(this);
        this.calculateGroupChecked = this.calculateGroupChecked.bind(this);

        this.state = {
            loading: true,
            email: "",
            support_email: "",
            notifications: {},
            user_notifications: {},
            selected_notifications: {},
            previous_notifications: {},
        };
    }

    componentDidMount() {
        document.title = "Unsubscribe - FleetXPress"
        var self = this;
        var url = '/ajax/unsubscribe/' + self.props.match.params.unique_id;

        axios.get(url)
            .then(function(response) {
                self.setNotifications(response?.data.notifications, response?.data.user_notifications);
                self.setState({
                    loading: false,
                    email: response?.data.email,
                    support_email: response?.data.support_email,
                    notifications: response?.data.notifications,
                    user_notifications: response?.data.user_notifications,
                })
            })
            .catch(function(error) {
                if(error.response?.status == 401) {
                    self.props.history.push("/")
                    showStatusMsg("The link you have provided is not valid.")
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
    }

    setNotifications(notifications, user_notifications) {
        var self = this;
        var selected_notifications = new Array();
        var previous_notifications = new Array();
        notifications.map((notification, i) => {
            var u_notification = (user_notifications.find(user_notification => user_notification.Notification_ID === notification.ID));
            selected_notifications[notification.ID] = {Category_ID: notification.category.ID, Active: (u_notification != undefined ? u_notification.Active : 1)};
        });

        previous_notifications = $.extend(true, [], selected_notifications);

        self.setState({
            selected_notifications: selected_notifications,
            previous_notifications: previous_notifications
        })
    }

    calculateSave() {
        var class_name = "";
        var previous_notifications = this.state.previous_notifications;
        var selected_notifications = this.state.selected_notifications;

        if(Object.keys(previous_notifications).length === Object.keys(selected_notifications).length && Object.keys(previous_notifications).every(key => selected_notifications.hasOwnProperty(key) && previous_notifications[key].Active === selected_notifications[key].Active))
        {
            class_name = "button primary px-32 disabled";
        }
        else
        {
            class_name = "button primary px-32";
        }

        return class_name;
    }

    calculateChecked(notification) {
        if(this.state.selected_notifications[notification.ID] !== undefined && this.state.selected_notifications[notification.ID].Active === 1)
        {
            return "checked";
        }

        return "";
    }

    calculateGroupChecked(category) {
        var allChecked = true;
        var categoryExists = false;
        
        this.state.selected_notifications.map((notification, id) => {
            if(category.ID == notification.Category_ID)
            {
                categoryExists = true;

                if(notification.Active === 0)
                {
                    allChecked = false;
                }
            }
        });

        return ((allChecked && categoryExists) ? "checked" : "")
    }

    handleChange(event, notification) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        
        var self = this;
        var selected_notifications = this.state.selected_notifications;

        selected_notifications[notification.ID].Active = value ?  1 : 0;

        self.setState({
            selected_notifications: selected_notifications
        })
    }

    unsubscribeAll(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;

        var self = this;
        var notifications = this.state.notifications;
        var selected_notifications = this.state.selected_notifications;

        selected_notifications.map((notification, id) => {
            var current_notification = (notifications.find(notification => id === notification.ID));
            if(current_notification.Name != 'Account Info') {
                notification.Active = value ?  0 : 1;
            }
        });
        
        self.setState({
            selected_notifications: selected_notifications
        })
    }

    selectAll(event, category) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;

        var self = this;
        var selected_notifications = this.state.selected_notifications;

        selected_notifications.map((notification, id) => {
            if(category.ID == notification.Category_ID)
            {
                notification.Active = value ?  1 : 0;
            }
        });
        
        self.setState({
            selected_notifications: selected_notifications
        })
    }

    submitNotifications(event) {
        var self = this;
        var url = '/ajax/unsubscribe/' + self.props.match.params.unique_id;
        var previous_notifications = this.state.previous_notifications;
        var selected_notifications = this.state.selected_notifications;

        axios.post(url, {
            'notifications': this.state.selected_notifications,
            })
            .then(function(response) {
                showStatusMsg(response?.data.message, 'success');

                previous_notifications = $.extend(true, [], selected_notifications);

                self.setState({
                    previous_notifications: previous_notifications
                })
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    self.props.history.push("/")
                    showStatusMsg("The link you have provided is not valid.")
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }

                if (self.props.closeModal) self.props.closeModal();
            })
    }

    render() {
        if(!this.state.loading) {
            return (
                <div className = "bkg-white-dark pb-24">
                    <div className = "l-786-wrapper list-wrapper">
                        <div className = "card">                            
                            <div className = 'card-section'>
                                <div className = 'row collapse'>
                                    <div className="unsubscribe_page">
                                        <div className="user_info_details">
                                            <div className="user_info_details_header black">
                                                <Trans>Unsubscribe</Trans>
                                            </div>
                                            <div className="user_info_details_email black">
                                                { this.state.email }
                                            </div>
                                            <div className="user_info_row">
                                                <div className="notifications-container">
                                                    <div className="notifications-row">
                                                        <div className="notifications-header notifications-email-column"><Trans>Email</Trans></div>
                                                        <div className="notifications-header notifications-sms-column"><Trans>SMS*</Trans></div>
                                                        <div className="notifications-header notifications-desc-column"></div>
                                                    </div>
                                                    {
                                                        this.state.notifications.map((notification, i) =>
                                                            i == 0 || this.state.notifications[i - 1].category.Name != this.state.notifications[i].category.Name ?
                                                                <>
                                                                    <div className="notifications-row notifications-heading">
                                                                        <div className="notifications-email-column">
                                                                            <label className="notifications-checkbox-label">
                                                                                <input type="checkbox" name="" data-category={this.state.notifications[i].category.ID} className="email-bookings-selectall" checked={this.calculateGroupChecked(this.state.notifications[i].category)} onChange={(e) => this.selectAll(e, this.state.notifications[i].category)} disabled={ notification.category.Name == 'Account Updates' ? "disabled" : ""} />
                                                                                <span className={"notifications-checkbox-custom" + (notification.category.Name == 'Account Updates' ? " notifications-checkbox-disabled" : "")}></span>
                                                                            </label>
                                                                        </div>
                                                                        <div className="notifications-sms-column">
                                                                            <label className="notifications-checkbox-label">
                                                                                <input type="checkbox" name="" onChange={this.handleChange} checked="" />
                                                                                <span className="notifications-checkbox-custom"></span>
                                                                            </label>
                                                                        </div>
                                                                        <div className="notifications-desc-column">{ notification.category.Name }</div>
                                                                    </div>
                                                                    <div className="notifications-row">
                                                                        <div className="notifications-email-column">
                                                                            <label className="notifications-checkbox-label">
                                                                                <input type="checkbox" className="email-bookings-group" name="" checked={ this.calculateChecked(notification) } onChange={(e) => this.handleChange(e, notification)} disabled={ notification.Name == 'Account Info' ? "disabled" : ""} />
                                                                                <span className={"notifications-checkbox-custom" + (notification.Name == 'Account Info' ? " notifications-checkbox-disabled" : "")}></span>
                                                                            </label>
                                                                        </div>
                                                                        <div className="notifications-sms-column">
                                                                            <label className="notifications-checkbox-label">
                                                                                <input type="checkbox" name="" onChange={this.handleChange} />
                                                                                <span className="notifications-checkbox-custom"></span>
                                                                            </label>
                                                                        </div>
                                                                        <div className="notifications-desc-column">
                                                                            <div className="notifications-desc-header">{ notification.Name }</div>
                                                                            <div className="notifications-desc-desc">{ notification.Description }</div>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            :
                                                                <div className="notifications-row">
                                                                    <div className="notifications-email-column">
                                                                        <label className="notifications-checkbox-label">
                                                                            <input type="checkbox" className="email-bookings-group" name="" data-category={this.state.notifications[i].category.ID} checked={ this.calculateChecked(notification) } onChange={(e) => this.handleChange(e, notification)} disabled={ notification.Name == 'Account Info' ? "disabled" : ""} />
                                                                            <span className={"notifications-checkbox-custom" + (notification.Name == 'Account Info' ? " notifications-checkbox-disabled" : "")}></span>
                                                                        </label>
                                                                    </div>
                                                                    <div className="notifications-sms-column">
                                                                        <label className="notifications-checkbox-label">
                                                                            <input type="checkbox" name="terms" onChange={this.handleChange} />
                                                                            <span className="notifications-checkbox-custom"></span>
                                                                        </label>
                                                                    </div>
                                                                    <div className="notifications-desc-column">
                                                                        <div className="notifications-desc-header">{ notification.Name }</div>
                                                                        <div className="notifications-desc-desc">{ notification.Description }</div>
                                                                    </div>
                                                                </div>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                            <div className="user_info_row notification-unsubscribe">
                                                <div className="notifications-container">
                                                    <div className="notifications-row">
                                                        <div className="notifications-email-column">
                                                            <label className="notifications-checkbox-label">
                                                                <input type="checkbox" className="email-bookings-group" name="" onChange={this.unsubscribeAll} />
                                                                <span className="notifications-checkbox-custom"></span>
                                                            </label>
                                                        </div>
                                                        <div className="notifications-sms-column">
                                                            <label className="notifications-checkbox-label">
                                                                <input type="checkbox" name="terms" />
                                                                <span className="notifications-checkbox-custom"></span>
                                                            </label>
                                                        </div>
                                                        <div className="notifications-desc-column">
                                                            <div className="notifications-desc-desc"><Trans>I want to unsubscribe from all emails</Trans></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="user_info_row notification-save">
                                                <div className={this.calculateSave()} onClick={(e) => this.submitNotifications(e)}><span className="mr-8 ml-8"><Trans>Update</Trans></span></div>
                                                <br /><br />
                                                <div className="unsubscribe-support-message"><Trans>For further inquiries, please</Trans> <a href={"mailto: " + this.state.support_email}><Trans>contact support</Trans></a>.</div>
                                                <br /><br />
                                                <div className="unsubscribe-footer">
                                                    <img src="/images/default-email-logo.png" />
                                                    <div className="unsubscribe-footer-header">FleetXPress</div>
                                                    <div className="unsubscribe-footer-links"><a href='/eula'><Trans>Terms of Use</Trans></a> | <a href='/privacy'><Trans>Privacy Policy</Trans></a></div>
                                                    <div className="unsubscribe-footer-description">©2022 FleetXPress</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div id = 'clear'></div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <LoadingIcon />
            );
        }
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession
})

export default connect(mapStateToProps)(Unsubscribe)